news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, HY교육과 '지방소멸 위기 극복' 위한 업무협약 체결</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌, HY교육과 '지방소멸 위기 극복'&nbsp;위한 업무협약 체결</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;에듀윌- HY교육,&nbsp;지역 소멸 대응 위한 진학·취업 통합 지원 체계 마련</strong></span>
                              </p>
                              <p><span style="font-family:'맑은 고딕';"><strong>- “해외 대학생 유입 통해 소멸 위기 처한 지자체에 새로운 활력 불어넣을 것”</strong></span>
                              </p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605134339.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">[사진설명]&nbsp;에듀윌 양형남 대표(좌측)와 HY교육 전대근 대표가 업무협약서에 서명하고,&nbsp;기념 촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">(2025-03-27) 종합교육기업 에듀윌(대표 양형남)이 지난 26일 서울 구로구 본사에서 HY교육(대표 전대근)과 ‘지방소멸 위기 극복’을 위한 업무협약(바인딩 MOU)을 체결했다고 27일 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 협약은 해외 대학생의 국내 대학 진학과 취업을 연계하여 지역 인재 유입 및 정착을 도모하고,&nbsp;이를 통해 지방소멸 위기에 대응하는 지속 가능한 모델을 구축하는 데 목적이 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">HY교육은 국내 학생들의 대학 진학지도를 중심으로 성장해 왔으며,&nbsp;현재는 해외 학생들의 한국 대학 진학으로 사업 범위를 넓히고 있다.&nbsp;기존의 진로?진학 특허 기반 컨설팅을 토대로 우수한 외국인 유학생을 선발하고,&nbsp;현지에서 MFC(Mega Foundation Course,&nbsp;메가 파운데이션 코스)를 통해 교육하며 현재 베트남?우즈베키스탄을 포함 그 범위를 확대하려고 한다.&nbsp;</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">양사는 이번 협약을 통해 우즈베키스탄을 비롯해 다양한 국적의 해외 대학생들이 지역대학에 진학하고,&nbsp;졸업 후 국내 기업에 안정적으로 취업할 수 있도록 체계적인 교육과 취업 지원 프로그램을 제공할 예정이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">특히 이 협업은 지방소멸 위기에 직면한 국내 지역에 해외 대학생을 배치함으로써,&nbsp;실제적인 인구 유입 효과를 기대할 수 있다는 점에서 큰 의미가 있다.&nbsp;오는 9월 시범사업을 시작으로 점진적인 확대를 통해 2026년 9월부터 매년 1,000여 명 규모의 유학생 유치를 목표로 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">한편,&nbsp;전국 17개 광역시도 가운데 소멸 위험지역 1순위로 꼽히는 충남을 비롯해,&nbsp;경남,&nbsp;강원도,&nbsp;전북,&nbsp;경북,&nbsp;전남 지역이 현재 인구 감소에 따른 소멸 위험에 진입했다.&nbsp;강원도의 경우,&nbsp;소멸 위기 대응을 위해 ‘자녀 1인당 1억 원 지원’&nbsp;등의 파격적인 정책을 추진 중이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">HY교육은 외국인 학생의 국내 대학 입학을 위한 전반적인 절차를 총괄하며,&nbsp;맞춤형 지원 체계를 통해 원활한 정착을 돕는다.&nbsp;아울러 실질적인 취업 기회를 제공하기 위해 정부 및 민간 기업과의 전략적 협력도 추진할 예정이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌은 유학생들의 취업 경쟁력 강화를 위해 한국산업인력공단의 EPS(고용허가제)&nbsp;관련 자격 과정과 더불어,&nbsp;국내외 기업이 요구하는 직무 역량 향상 교육을 독점적으로 운영한다.&nbsp;또한 교육 콘텐츠 개발,&nbsp;커리큘럼 설계,&nbsp;교재 제작,&nbsp;강사 채용 등 교육과정의 기획부터 운영까지 전 과정을 담당한다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">양형남 에듀윌 대표는 “해외 대학생 유입은 인구 감소로 소멸 위기에 처한 지방자치단체에 새로운 활력을 불어넣을 수 있는 현실적인 대안”이라며, “HY교육과의 협력을 통해 실질적인 취업 연계가 가능한 교육 프로그램 개발에 최선을 다하겠다”고 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">전대근 HY교육 대표는 “에듀윌은 자격증과 직무 교육에 특화된 전문기관으로,&nbsp;취업 연계 교육에 대한 폭넓은 경험과 역량을 갖추고 있다”며, “이번 협약을 계기로 지방 도시들이 직면한 인구 소멸 문제 해결에 힘을 보탤 수 있기를 기대한다”고 말했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 HY교육과의 업무 협약은 올해 에듀윌의 핵심 사업 중 하나인 시니어 및 다문화 교육 사업의 일환이다.&nbsp;에듀윌은 블루칼라 자격증 시장 선점에 이어,&nbsp;시니어와 다문화 대상 맞춤 교육으로 사업 영역을 더욱 확장해 나갈 계획이다.</span>
                              </p>
                              <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news21" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌×아이헤이트플라잉버그스, AI 기반 온택트 학습 MOU 체결’</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news19" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 폭스에듀와 MOU 체결… ‘미래 교육 판도 대변혁 시동'</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
